import usePayment from "app/hooks/shared/payment/usePayment";
import { useCartContext } from "app/providers/CartProvider";
import {
  OrderType,
  usePaymentContext,
} from "pages/payment/providers/PaymentProvider";
import { useEffect, useState } from "react";
import { concatClassnames } from "shared/utils/concatClassnames";
import {
  PaymentType,
  paymentTypesLater,
  paymentTypesRemaining,
} from "shared/utils/payment";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";

interface Props {
  className?: string;
}

const StandardProductPayment = ({ className }: Props) => {
  const {
    paymentAction,
    setPaymentAction,

    setBank,
    setPaymentMethod,
  } = usePaymentContext();

  const { getPaymentTypeList } = usePayment();
  const {
    changeCartStandardProductPaymentBank,
    changeCartStandardProductPaymentMethod,
    getCart,
  } = useCartContext();
  const cart = getCart();
  const [paymentTypes, setPaymentTypes] = useState<PaymentType[]>([]);

  useEffect(() => {
    fetchPaymentTypes();
  }, []);

  const fetchPaymentTypes = async () => {
    const types =
      (await getPaymentTypeList([
        ...paymentTypesRemaining,
        ...(cart.totalPrice >= 250 ? paymentTypesLater : []),
      ])) ?? [];
    setPaymentTypes(types);
  };

  return cart.products.length === 0 && cart.standardProducts.length > 0 ? (
    <div className={concatClassnames("", className)}>
      <div className={concatClassnames()}>
        {
          <PaymentMethods
            method={PaymentMethod.DEFERRED_PAYMENT}
            types={paymentTypes}
            paymentAction={paymentAction}
            setPaymentAction={(method) => {
              setPaymentAction(method);
            }}
            orderType={OrderType.STANDARD_PRODUCT}
          />
        }
      </div>
    </div>
  ) : (
    <></>
  );
};
export default StandardProductPayment;
